import { render, staticRenderFns } from "./TodosList.vue?vue&type=template&id=679ccdcf&scoped=true&"
import script from "./TodosList.vue?vue&type=script&lang=js&"
export * from "./TodosList.vue?vue&type=script&lang=js&"
import style0 from "./TodosList.vue?vue&type=style&index=0&id=679ccdcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ccdcf",
  null
  
)

export default component.exports